module.exports = __webpack_public_path__ + "img/symbol_0.68f109c3.png";